export default __webpack_public_path__ + "static/media/tete24.c4c51bcc.png";